import { render, staticRenderFns } from "./ProjectJoin.vue?vue&type=template&id=27f7ce85&"
import script from "./ProjectJoin.vue?vue&type=script&lang=ts&"
export * from "./ProjectJoin.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectJoin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports